module.exports = __webpack_public_path__ + "static/ajdental-ce401237629931137b075b3ac2d579bb.svg";